<ng-container *ngFor="let breadcrumb of navigationList; let last = last">
  <div
    class="page-header"
    *ngIf="last && breadcrumb.breadcrumbs !== false"
    [class.page-header--hide-single-mobile]="hideSingleCrumbOnMobile"
    [class.page-header--with-back]="showToolbarBack()">
    <div class="page-block" [class.page-block--toolbar]="showToolbarBack()">
      <div class="row align-items-center page-header__content">
        <div class="col-md-12">
          <div class="page-header-title"></div>
          <ul class="breadcrumb" [class.page-header__breadcrumb]="showToolbarBack()">
            <ng-container *ngFor="let breadcrumb of navigationList; let isLast = last">
              <li class="breadcrumb-item" *ngIf="breadcrumb.url !== false" [class.active]="isLast">
                <a [routerLink]="breadcrumb.url">{{ breadcrumb.translateTitle === false ? breadcrumb.title : (breadcrumb.title | translate) }}</a>
              </li>
              <li class="breadcrumb-item" *ngIf="breadcrumb.url === false" [class.active]="isLast">
                <a href="javascript:">{{ breadcrumb.translateTitle === false ? breadcrumb.title : (breadcrumb.title | translate) }}</a>
              </li>
            </ng-container>

            <li class="breadcrumb-item active" *ngIf="getActiveTabTitle()">
              <a href="javascript:">{{ getActiveTabTitle() | translate }}</a>
            </li>
          </ul>
        </div>
      </div>

      <app-ad-back-button
        *ngIf="showToolbarBack()"
        class="page-header__back"
        [text]="isOnDetailProduct() ? ('CfCategoryList.back' | translate) : undefined"
        (clicked)="goBackFromToolbar()">
      </app-ad-back-button>
    </div>
  </div>
</ng-container>
